import {Space} from "antd";
import {StyledFormWrapper, StyledFormWrapperHeading} from "./styles";
import {PropsWithChildren} from "react";

export type FormWrapperProps = PropsWithChildren<{
  title?: string;
  borderless?: boolean;
}>;

export function FormWrapper({borderless, children, title}: FormWrapperProps) {
  return (
    <StyledFormWrapper $borderless={borderless}>
      <Space direction="vertical" size={title ? 24 : 0} style={{display: "flex"}}>
        {title && (
          <StyledFormWrapperHeading>
            <h1 className="main-heading">{title}</h1>
          </StyledFormWrapperHeading>
        )}

        {children}
      </Space>
    </StyledFormWrapper>
  );
}
